import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { name: '首页', path: '/' },
    { name: '动漫分类', path: '/category/rexue-zhandou' },
    { name: '关于我们', path: '/about' },
  ],
  categories: [
    { name: '热血战斗', path: '/category/rexue-zhandou' },
    { name: '玄幻修仙', path: '/category/xuanhuan-xiuxian' },
    { name: '搞笑日常', path: '/category/gaoxiao-richang' },
    { name: '科幻机甲', path: '/category/kehuan-jijia' },
    { name: '古风国漫', path: '/category/gufeng-guoman' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-ancient-gate-line text-xl text-background-50"></i>
              </div>
              <span className="text-lg font-bold text-foreground-50 font-heading">51动漫</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              51动漫官网 —— 国产动漫爱好者的一站式内容平台。提供最新动漫资讯、深度作品解析和分类推荐，让每一位动漫爱好者都能找到属于自己的精彩。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              <a href="#footer-nav" className="no-underline text-foreground-100">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              <a href="#footer-cats" className="no-underline text-foreground-100">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              <a href="#footer-contact" className="no-underline text-foreground-100">联系我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line text-foreground-500"></i>
                <span>contact@51anime.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-wechat-line text-foreground-500"></i>
                <span>51动漫官方</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-bilibili-line text-foreground-500"></i>
                <span>51动漫B站</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 51动漫官网 版权所有 | 51动漫网 | 51动漫网站 | 51动漫国产精品入口
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}